<template>
  <div class="invite-footer">
    <button
      v-if="state.backTo"
      class="button-primary button-back"
      @click="
        handlers.changeCurrentState(state.backTo);
        clickedBack();
      "
    >
      Back
    </button>
    <div
      v-if="state.goToBulk"
      class="invite-multiple"
      :class="{ 'invite-multiple-hidden': maxUsers }"
    >
      <span class="invite-multiple-text">
        To add many people at once,
        <span @click="handlers.changeCurrentState(state.goToBulk)"
          >click here.</span
        >
      </span>
    </div>
    <button
      class="button-primary button-action"
      :class="{ process: process }"
      :disabled="shouldActivate ? false : true"
      @click="handlers.action()"
    >
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
/**
 *  InviteFooter
 * */
import Analytics from 'c/WtAnalytics';

export default {
  props: {
    state: {
      type: Object,
      required: true,
    },

    handlers: {
      type: Object,
      required: true,
    },
  },

  computed: {
    buttonText: function () {
      const currentState = this.handlers.currentState;
      const onlyOneProgrammer = this.handlers.isOnlyOneProgrammer();
      const hasProductionLine = this.handlers.hasProductionLine;
      const processDirty = this.handlers.processDirty;

      let buttonText = '';

      switch (currentState.name) {
        case 'invite':
          buttonText =
            onlyOneProgrammer || (hasProductionLine && processDirty)
              ? 'Invite'
              : 'Next';
          break;
        case 'bulk':
          buttonText = 'Add Invitations';
          break;
        case 'production':
          buttonText = onlyOneProgrammer ? 'Invite' : 'Invite All';
          break;
      }

      return buttonText;
    },

    process: function () {
      return this.handlers.process;
    },

    shouldActivate: function () {
      return this.handlers[this.state.disabled] && !this.process;
    },

    maxUsers: function () {
      return this.handlers.isMaxUsers;
    },
  },

  methods: {
    clickedBack: function () {
      Analytics.trigger('analytics:invitations:back');
    },
  },
};
</script>
